import ReactDOM from 'react-dom/client';

import { Application } from '@/modules/application';
import { Core } from '@/modules/core/components/Core';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(container);

root.render(
    <Core>
        <Application />
    </Core>,
);
